export enum AnswerSkipReasonEnum {
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  NO_VISIBILITY = 'NO_VISIBILITY',
}
